<template>

  <div  clearfix class="clearfix main_center">
    <div class="content">

      <!--Video-->
      <div class="flvPlayerWrapper" :style="{height:videoHeight + 'px'}">
        <streamPlayer
                ref="streamPlayerRef"
                :videoUrl.sync="videoUrl"
                :height="videoHeight.toString()"
                videoCode="flv"
                @cutAndUploadSuccess="addTableData">
        </streamPlayer>
        <placeAndEquipment
                ref="placeAndEquipmentRef"
                :showSrcSwitch="true"
                roomType="1"
                :currentVideo.sync="currentVideo"
                :videoSwitchData.sync="videoSrcData"
                @switchCurrentVideo="switchVideoUrl">
        </placeAndEquipment>

      </div>

        <el-form ref="form" :model="form" :rules="roles" label-width="120px" class="form" style="margin-top: 12px">
          <el-row :gutter="15">
            <el-col :span="24">
              <el-form-item :label="form.dataGroup=='1'?'关联项目：':'关联标段：'" prop='releProjectName'  style="width: calc(100% - 200px);display: inline-block">
                <el-input v-model="form.releProjectName" disabled ></el-input>
              </el-form-item>
              <div style="display: inline-block;float: right" >
                <el-button size="mini" @click="showListDialog"  style="margin-right: 10px;margin-top: 2px">...</el-button>
                <el-checkbox v-model="form.dataGroup" true-label='1' false-label='2' @change="resetFormData">按招标项目抽取</el-checkbox>
              </div>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="见证记录：" prop='witnessContent' >
                <el-input type="textarea" :rows="3" :disabled="disableEdit" v-model="form.witnessContent" maxlength="600"  show-word-limit clearable ></el-input>
              </el-form-item>
            </el-col>
          </el-row>


          <el-row>
            <el-col :span="11">
              <el-form-item label="见证人：" >
                <el-input   v-model="form.witnessUserName" disabled ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" :offset="1">
              <el-form-item label="视频截取：" prop="datetimerange" :error="datetimerangeerror" >
                <el-time-picker
                        is-range
                        :disabled="disableEdit"
                        v-model="timeRange"
                        :editable="false"
                        range-separator="至"
                        format="HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="{
                          selectableRange: '08:00:00-20:00:00'
                        }"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围">
                </el-time-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="11">
              <el-form-item label="所属交易中心：" prop='tradeId'>
                <el-select v-model="form.tradeId"  style="width:100%;">
                  <el-option v-for="(item) in transactionCenterList" :key="item.id" :label="item.orgName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="记录关键帧："  >
                <el-button size="mini" :disabled="disableEdit" @click="cutScreenAndUpload" >+   添加</el-button>
              </el-form-item>
            </el-col>
          </el-row>


          <el-row >
            <el-col :span="24">
              <el-table
                      :data="tableDataDetail"
                      border
                      v-loading="keyListLoading"
                      @cell-click="cellClick"
                      style="width: calc(100% - 100px);margin-left: 100px">
                <el-table-column
                        header-align="center"
                        label="序号"
                        width="50"
                        type="index"
                        align="center">
                </el-table-column>
                <el-table-column
                        header-align="center"
                        label="操作"
                        width="80"
                        align="center">
                  <template slot-scope="scope">
                    <el-button :disabled="disableEdit" @click="removeTableData(scope.row)" type="text"  size="small">移除</el-button>
                  </template>
                </el-table-column>
                <el-table-column
                        prop="recordTime"
                        header-align="center"
                        label="时间"
                        width="180"
                        align="center">
                  <template scope="scope">
                    <span style="margin-left: 10px" >{{ formatDate( scope.row.recordTime,'HH:mm:ss')}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="快照" align="center" width='100'>
                  <template slot-scope="scope">
                    <img :src="scope.row.screenshotUrl" @click="showImgDialog(scope.row.screenshotUrl)" v-if="scope.row.screenshotUrl" class="thumbnail" alt="">
                  </template>
                </el-table-column>
                <el-table-column
                        prop="remark"
                        header-align="center"
                        label="备注">
                  <template scope="scope">
                    <span style="margin-left: 10px" v-show="!scope.row.seen || disableEdit">{{ scope.row.remark }}</span>
                    <el-input v-model="scope.row.remark"  @blur="loseFcous(scope.row,this)" type="textarea" v-show="scope.row.seen && !disableEdit" maxlength="200" show-word-limit> </el-input>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>


          <div style="float: right;margin: 10px 0px">
            <el-button type="primary" :disabled="disableEdit" @click="save(-1)">保存</el-button>
            <el-button type="primary" :disabled="disableEdit" @click="commit">提交</el-button>
          </div>
          <div style="clear: both"></div>

        </el-form>



    </div>


      <!--选择项目弹框-->
      <el-dialog :title="form.dataGroup == '1'?'选择项目':'选择标段'" @opened="dialogOpen" :visible.sync="projectListDialog">

        <template>
          <div  style="padding: 12px">
            <el-table
                    border
                    v-loading="dataListLoading"
                    v-if="form.dataGroup == '1'"
                    :data="tableDataProject"
                    style="width: 100%">
              <el-table-column
                      header-align="center"
                      label="序号"
                      width="80"
                      type="index"
                      align="center">
              </el-table-column>
              <el-table-column
                      header-align="center"
                      label="操作"
                      width="120"
                      align="center">
                <template slot-scope="scope">
                  <el-button @click="selectProject(scope.row)" type="text"  size="small">选择</el-button>
                </template>
              </el-table-column>
              <el-table-column
                      prop="projectName"
                      label="项目名称"
                      align="center">
              </el-table-column>
              <el-table-column
                      prop="projectCode"
                      label="项目编号"
                      width="180"
                      align="center">
              </el-table-column>
              <el-table-column
                      prop="dataSourceName"
                      label="数据来源"
                      width="120"
                      align="center">
              </el-table-column>
            </el-table>
            <el-table
                    border
                    v-loading="dataListLoading"
                    :data="tableDataBid"
                    v-if="form.dataGroup == '2'"
                    style="width: 100%">
              <el-table-column
                      header-align="center"
                      label="序号"
                      width="80"
                      type="index"
                      align="center">
              </el-table-column>
              <el-table-column
                      header-align="center"
                      label="操作"
                      width="120"
                      align="center">
                <template slot-scope="scope">
                  <el-button @click="selectBid(scope.row)" type="text"  size="small">选择</el-button>
                </template>
              </el-table-column>
              <el-table-column
                      prop="bidName"
                      label="标段名称"
                      align="center">
              </el-table-column>
              <el-table-column
                      prop="bidCode"
                      label="标段编号"
                      :show-tooltip-when-overflow="true"
                      width="250"
                      align="center">
              </el-table-column>
              <el-table-column
                      prop="dataSourceName"
                      label="数据来源"
                      width="120"
                      align="center">
              </el-table-column>
            </el-table>
<!-- 
            <el-pagination background

                           layout="sizes, prev, pager, next"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="pageSize"
                           :total="total"
                           :current-page="pageIndex"
                           @size-change="sizeChangeHandle"
                           @current-change="currentChangeHandle">
            </el-pagination> -->
            <pagination
                class="limit"
                :page-sizes="[10, 20, 50, 100]"
                :total="total"
                :page.sync="pageIndex"
                :limit.sync="pageSize"
                @pagination="paginationChange">
            </pagination>
          </div>
        </template>

<!--        <div slot="footer" class="dialog-footer">-->
<!--          <el-button @click="projectListDialog = false" type="primary">关 闭</el-button>-->
<!--        </div>-->

      </el-dialog>

      <el-dialog  @opened="dialogOpen" fullscreen @closed="dialogClose" :visible.sync="imgDialogVisible" >
        <template>
          <img :src="dialogImageUrl" alt="" @contextmenu.prevent=""  class="viewImg">
        </template>
      </el-dialog>




  </div>
</template>



<script>
    import {mapState} from "vuex";
    import streamPlayer from "@/components/videoPlayer/streamPlayer";
    import placeAndEquipment from "@/components/videoPlayer/placeAndEquipment";
    import {validateDate} from "@/utils/validate";
    import {tabsCloseCurrentHandle} from '@/utils/routeTab';
    import {isIEBrowser, scrollToTop} from '@/utils/index';
    import Pagination from '@/components/Pagination.vue';

    export default {
    components: {
      streamPlayer,
      placeAndEquipment,
      Pagination
    },
  data(){
    return{
      dataListLoading: false,
      id: "1",
      //  标段或者项目选择弹窗
      projectListDialog :false,
      isIE:false,
      imgDialogVisible:false,
      keyIframeTime:'', // 关键帧截取时间
      keyListLoading:false,
      dialogImageUrl:"",
      currentVideo:{},
      videoHeight:750,
      videoWidth:document.documentElement.clientWidth-302,
      videoSrcData:[],
      videoUrl:"",
      timeRange:[(this.formatDate( new Date(),'yyyy-MM-dd') + ' 08:00:00'),(this.formatDate( new Date(),'yyyy-MM-dd') + ' 20:00:00')],
      roles: {
        releProjectName: [{required: true, message: '请选择项目', trigger: 'blur'}],
        witnessContent: [{required: true, message: '请填写见证记录', trigger: 'blur'}],
        witnessUserId: [{required: true, message: '请选择项目', trigger: 'blur'}],
        datetimerange: [{ type: 'date', required: true,validator: validateDate, message: '请选择起止日期', trigger: 'change' }],
      },
      showMoreInfo:false,
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      releProjectName:"", // 关联的项目或者标段名称 //展示在页面的项目名或者标段名
      form:{    //见证数据
        id: "",          //见证数据ID
        releProjectName:"", // 关联的项目或者标段名称 //展示在页面的项目名或者标段名
        bidopenTime: "", //开标时间
        businessId: "",  //关联的项目ID
        businessexId: "",//关联的标段ID
        createTime: "",  //创建时间
        createUser: "",  //创建人
        dataGroup: "2",   //是否关联项目  1:关联项目  2:关联标段  (默认为不勾选，关联标段)
        dataType: "1",    //见证类型     1专家抽取见证 2开标见证 3评标见证
        delFlag: false,
        detailList: [], //见证明细数据
        evalEtime: "",  //评标结束时间
        evalStime: "",  //评标开始时间
        field1: "",
        field2: "",
        field3: "",
        fileTypeDictCode: "",
        fileTypeMap: {},
        historyid: "",  //-1:暂存   0:已生效
        remark: "",     //备注
        updateTime: "", //更新时间
        updateUser: "", //更新用户
        videoEtime: "", //视频结束时间
        videoStime: "", //视频开始时间
        witnessContent: "",
        witnessUserId: '',
        witnessUserName:"",
        dataSource:"",  // 数据来源1工程2采购
        tradeId: '',
        project: {  //项目数据
          id: "",
          projectCode: "",   //项目编号
          projectName: "",   //项目名称
          tenderAgencyName: "", //招标代理机构名称
          tendererName:""   //招标人名称
        },
        bid:{ //标段数据
          bidCode: "",
          bidName: "",
          hasRecord: 0,
          id: "",
          projectCode: "",
          status: 0
        },
      },
      tableDataDetail: [],  //明细列表
      tableDataProject:[],
      tableDataBid:[],
      errorData:{},

      endDateTimeOption:{
        selectableRange:"18:30:00-23:30:00"
      },
      transactionCenterList: [],

    }


  },
  computed:{
    ...mapState({
      stateData:state=>state.user
    }),
    datetimerangeerror:function () {
      return this.errorData.starttime;
    },
    disableEdit:function () {
      return this.form.historyid == 0?true:false;
    },

  },
    created() {
      this.isIE = isIEBrowser();
      this.transactionCenterList = JSON.parse(sessionStorage.getItem("transactionCenterList"));

    },

    activated(){

      // this.form.id = (this.$route.params && this.$route.params.id ) || '' ;
      // this.getDataById(this.id);

      if(this.form.businessId){

        if(this.form.dataGroup == '1'){
          // 获取见证数据
          this.getWitnessDetail(this.form.businessId,'project','')

        }else if(this.form.dataGroup == '2'){
          // 获取见证数据
          this.getWitnessDetail(this.form.businessexId,'bid','')

        }

      }

      this.$nextTick(() => {
        if(this.$refs.streamPlayerRef){
          this.$refs.streamPlayerRef.play(); // 播放
        }
      })

  },

    deactivated() {
      if(this.$refs.streamPlayerRef){
        this.$refs.streamPlayerRef.pause();  // 暂停
      }
    },
    mounted() {

      this.form.witnessUserName = this.stateData.displayName ;
      this.form.historyid = -1;
      this.form.releProjectName = "";
      this.releProjectName = "";
      this.videoHeight = document.documentElement.clientHeight<600?600:(document.documentElement.clientHeight-125 + (this.isIE?-80:0));

    },

    methods:{

      dialogOpen(){

        this.$nextTick(() => {
          this.iframeInsert(this.$el);
        });
      },

      resetFormData(){

        this.form.businessId ='';
        this.form.businessexId = '';
        this.form.releProjectName = '';
        this.releProjectName = '';
        this.form.id = '';
        this.form.witnessContent = '';
        this.form.historyid = -1;
        this.form.detailList=[];
        this.tableDataDetail = [];
        this.timeRange = [(this.formatDate( new Date(),'yyyy-MM-dd') + ' 08:00:00'),(this.formatDate( new Date(),'yyyy-MM-dd') + ' 20:00:00')];
        this.form.witnessUserName = this.stateData.displayName ;
        this.videoSrcData = [];
        this.videoUrl='';
        this.$refs.placeAndEquipmentRef.isLoading = false;

      },


      checkCutVideoTime(){

        let keyListLength =this.tableDataDetail.length;
        if(keyListLength>0){
          let  firstKeyTime = this.tableDataDetail[0] && this.tableDataDetail[0].recordTime || '' ;
          let  lastKeyTime = this.tableDataDetail[keyListLength-1] && this.tableDataDetail[keyListLength-1].recordTime || '' ;
          if(firstKeyTime && this.timeRange[0] && (new Date(this.timeRange[0].replace(/-/g,"/")).getTime() > new Date(firstKeyTime.replace(/-/g,"/"))) ){
            this.errorData = {
              starttime:"日期选择有误"
            }
            this.$message({
              type:'error',
              message:"有关键帧不在视频截取时间范围内，请修改后提交！"
            })
            return false;
          }

          if(lastKeyTime && this.timeRange[1] && (new Date(this.timeRange[1].replace(/-/g,"/")).getTime() < new Date(lastKeyTime.replace(/-/g,"/"))) ){
            this.errorData = {
              starttime:"日期选择有误"
            }
            this.$message({
              type:'error',
              message:"有关键帧不在视频截取时间范围内，请修改后提交！"
            })
            return false;
          }

        }
          this.errorData.starttime='';
          return true;


        // this.form.videoStime=this.timeRange[0]?this.timeRange[0]:(this.formatDate( new Date(),'yyyy-MM-dd') + ' 08:00:00');
        // this.form.videoEtime=this.timeRange[1]?this.timeRange[1]:(this.formatDate( new Date(),'yyyy-MM-dd') + ' 20:00:00');

      },

      sizeChangeHandle(val) {
        this.pageSize = val;
        this.pageIndex = 1
        this.getDataList()
      },
      currentChangeHandle (val) {
        this.pageIndex = val
        this.getDataList()

      },
      paginationChange(obj){
        this.pageIndex= obj.page||1
        this.pageSize=obj.limit||10
        this.getDataList();
    },
      getKeyIframeList() { // 获取列表数据

        if(this.form.id && this.currentVideo.id){
          this.keyListLoading = true;
          this.$http.get(`/trading/tradingWitDetails/getByWitnessIdAndDeviceCode?witnessId=${this.form.id}&deviceCode=${this.currentVideo.id}`)
                  .then(res=>{
                    this.keyListLoading = false;
              if(res.data.code =="1"){
                this.tableDataDetail = res.data.data;
                // this.tableDataDetail.forEach((item)=>{
                //   item.screenshotUrl = this.$http.adornUrl(item.screenshotUrl)
                // })
              }else{
                this.tableDataDetail = [];
              }
          })
        }

      },

      getDataList() { // 获取列表数据
        this.dataListLoading=true;
          if (this.form.dataGroup == "2") {
            this.$http.post('/tradding/traddingwitness/getBidVoListToday',{
                'page': this.pageIndex,
                'rows': this.pageSize,
            }).then(res=>{
              this.dataListLoading=false;
              this.tableDataBid = res.data.rows;
              this.total = res.data.total;
            })
          }else {
            this.$http.post('/tradding/traddingwitness/getProjectVoListToday',{
                'page': this.pageIndex,
                'rows': this.pageSize,
            }).then(res=>{
              this.dataListLoading=false;
              this.tableDataProject = res.data.rows;
              this.total = res.data.total;
            })
          }


      },

      //回写项目数据
      selectProject(row) {
        this.form.businessId = row.projectCode;
        this.form.businessexId = '';
        this.form.releProjectName = row.projectName;
        this.releProjectName = row.projectName;
        this.form.dataSource = row.dataSource;
        this.projectListDialog = false;

        // 获取见证数据
        this.getWitnessDetail(this.form.businessId,'project',this.form.dataSource)


      },

      //回写标段数据
      selectBid(row) {

        this.form.businessId = row.projectCode || '';
        this.form.businessexId = row.bidCode;
        this.form.releProjectName = row.bidName;
        this.releProjectName = row.bidName;
        this.form.dataSource = row.dataSource;
        this.projectListDialog = false;

        // 获取见证数据
        this.getWitnessDetail(this.form.businessexId,'bid',this.form.dataSource)


      },

      //通过项目id或者标段id 查询见证基本信息
      getWitnessDetail(id, type, dataSource){

        this.$http.get(`/tradding/traddingwitness/getWitnessByBidOrProject?code=${id}&type=${type}&dataSource=${dataSource}`).then(res=>{
          if(res.data.code==='1'){
            const data = res.data.data;

            this.form = {...data};

            let dataTime = [];
            dataTime[0] =data.videoStime?data.videoStime:(this.formatDate( new Date(),'yyyy-MM-dd') + ' 08:00:00');
            dataTime[1] =data.videoEtime?data.videoEtime:(this.formatDate( new Date(),'yyyy-MM-dd') + ' 20:00:00');
            this.timeRange = dataTime;
            this.form.witnessUserName = this.form.witnessUserName || this.stateData.displayName ;
            this.form.releProjectName = this.releProjectName;
          }else{
            // 无见证数据，重置表单数据
            this.form.id = '';
            this.form.witnessContent = '';
            this.form.historyid = -1;
            this.form.detailList=[];
            this.tableDataDetail = [];
            this.timeRange = [(this.formatDate( new Date(),'yyyy-MM-dd') + ' 08:00:00'),(this.formatDate( new Date(),'yyyy-MM-dd') + ' 20:00:00')];
            this.form.witnessUserName = this.stateData.displayName ;
            this.form.releProjectName = this.releProjectName;
          }

          // 获取视频源
          this.getVideoUrlList(id,type,1)
        })

      },


      //打开标段或项目列表 弹窗
      showListDialog() {
        this.projectListDialog=true;
        this.getDataList();


      },

      loseFcous(row, index) {
        row.seen=false;
      },
      cellClick(row,column, cell, event) {
        if(column.property == 'remark'){
          row.seen = true;
          //延时加载focus
          setTimeout(function () {
            // $(cell.lastChild).find("textarea").focus();
            // 上面代码find 在IE报错 "无法重新定义不可配置的属性“find”" 目前不知什么原因，只能用下面原生方法代替
            cell.lastChild.lastChild.firstElementChild.focus();
          },100);
        }
      },

      cutScreenAndUpload(){
        this.keyIframeTime =  this.formatDate( new Date(),'yyyy-MM-dd HH:mm:ss');
        const _this = this;

        if(this.form.id){
          if(this.isIE){
            scrollToTop(function(){
              _this.$refs.streamPlayerRef.cutVideoScreen();
            })
          }else{
            this.$refs.streamPlayerRef.cutVideoScreen();
          }
        }else{
          this.$message({
            type:'error',
            message:"请先保存见证记录信息"
          })
        }

        // 假数据添加一条关键帧
        // this.tableDataDetail.push({
        //   seen:false,
        //   date: '',
        //   parentId:this.form.id,
        //   recordTime: this.keyIframeTime || this.formatDate( new Date(),'yyyy-MM-dd HH:mm:ss') ,
        //   screenshotUrl:'',
        //   deviceCode:this.currentVideo.id,
        //   dataType:1, // 1 专家抽取 2 开标见证 3 评标
        //   remark: ''
        // });




      },

      //新增一条表格数据
      addTableData(screenshotUrl){



        if(screenshotUrl){

          const keyIframe = {
            seen:false,
            date: '',
            parentId:this.form.id,
            recordTime: this.keyIframeTime || this.formatDate( new Date(),'yyyy-MM-dd HH:mm:ss') ,
            screenshotUrl:screenshotUrl,
            deviceCode:this.currentVideo.id,
            dataType:1, // 1 专家抽取 2 开标见证 3 评标
            remark: ''
          }

          this.$http.post('/trading/tradingWitDetails/save',keyIframe).then(res=>{
            if(res.data.code == '1'){
              this.tableDataDetail.push(res.data.data);
            }else{
              this.$message({
                type:'error',
                message:res.data.msg
              })
            }
          })

        }

      },

      //移除表格的数据
      removeTableData(row) {

        this.$confirm(`确定要删除该数据?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post('/trading/tradingWitDetails/delete' ,{
            id: row.id,
          }).then(res => {
            if (res.data.code == '1') {
              this.$message({
                type: 'success',
                message: res.data.msg
              })
              this.getKeyIframeList();

            } else {
              this.$message({
                type: 'error',
                message: res.data.msg
              })
            }
          })
        })


      },

      backBtn(){ //返回
        tabsCloseCurrentHandle();
        this.clearData()
        this.$router.push({
          name:'expertWitness_list'
        })

      },

      switchVideoUrl(video){

        this.currentVideo = video;
        this.videoUrl = this.currentVideo.playUrl?this.currentVideo.playUrl:"";
        this.$nextTick(()=>{
          this.getKeyIframeList()
        })


      },


      getVideoUrlList(id,bizType,roomType){

        // 查询场地及场地的摄像头
        this.$http.get(`/tradding/traddingwitness/getFieldsAndDevice?code=${id}&roomType=${roomType}&bizType=${bizType}`).then(res=>{
          if(res.data.code==='1'){

            this.videoSrcData = res.data.data;
            if(this.videoSrcData[0] && this.videoSrcData[0].devices && this.videoSrcData[0].devices[0]){
              this.currentVideo=JSON.parse(JSON.stringify(this.videoSrcData[0].devices[0]));
              this.$refs.placeAndEquipmentRef.setCurrentVideo(this.currentVideo);

              this.$nextTick(()=>{
                this.getKeyIframeList()
              })


            }
            this.videoUrl = this.currentVideo.playUrl?this.currentVideo.playUrl:"";


          }else{
            this.videoSrcData = [];
            this.videoUrl="";
          }
        })
      },

      dialogClose() {
        this.dialogImageUrl = "";
        this.imgDialogVisible = false;
      },
      // 图片放大弹窗
      showImgDialog(filePath){
        this.dialogImageUrl=filePath;
        this.imgDialogVisible = true;

        this.$nextTick(()=>{
          this.iframeInsert(this.$el);
        })

      },

      save(status){ //新增&保存




        if(this.timeRange.length == 0){
          this.errorData = {
            starttime:"日期不能为空"
          }
          return
        }else{
          this.errorData.starttime='';
        }

        let checkVideoCutTime = this.checkCutVideoTime();
        if(!checkVideoCutTime){
          return
        }

        this.form.historyid = status;

        this.form.witnessUserId = this.stateData.userinfo.userId;
        this.form.videoStime=this.timeRange[0]?this.timeRange[0]:(this.formatDate( new Date(),'yyyy-MM-dd') + ' 08:00:00');
        this.form.videoEtime=this.timeRange[1]?this.timeRange[1]:(this.formatDate( new Date(),'yyyy-MM-dd') + ' 20:00:00');
        this.$refs['form'].validate((valid) => {
          if (valid) {
            //表格数据转储到detailList
            this.form.detailList = this.tableDataDetail;
            this.form.dataType = 1; //// 1 专家抽取见证 2 开标见证 3 评标见证

            if (status == -1) {//提交
              this.$http.post('/tradding/traddingwitness/save',this.form).then(res=>{
                if(res.data.code == '1'){
                  this.form={...res.data.data}
                  this.form.releProjectName = this.releProjectName;

                  this.$message({
                    type:'success',
                    message:res.data.msg,
                  })

                }else{
                  this.$message({
                    type:'error',
                    message:res.data.msg
                  })
                }
              });
            }else {
              this.$http.post('/tradding/traddingwitness/submit',this.form).then(res=>{
                if(res.data.code == '1'){
                  this.form={...res.data.data}
                  this.form.releProjectName = this.releProjectName;

                  this.$message({
                    type:'success',
                    message:res.data.msg,
                  })

                }else{
                  this.$message({
                    type:'error',
                    message:res.data.msg
                  })
                }
              });
            }


          }
        })
      },

      commit(){

        this.$confirm(`提交后无法再对该项目实时见证，确认提交?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.save(0)

        }).catch(() => {});


      }


  },


}
</script>

<style lang="less" scoped>
  .viewImg{
    hieght:100%;
    display: block;
    margin: 0 auto;
  }

.main_center{
  height: 100%;

  /deep/ .el-dialog__header{
    border-bottom: 0;
  }
  /deep/ .el-dialog__body{
    padding: 0 10px 20px 10px;
  }

  .content{

    .flvPlayerWrapper{
        width: 100%;
        height:750px;
        display: block;
        text-align: center;
        position: relative;

    }


    .thumbnail{
      width: 50px;
      height: 50px;
    }






    .set_btn{
      float:right;
      margin-bottom:20px;
    }
    .more_btn{
      text-align: center;
    }
    .upload-demo{
      display: flex;
      height: 34px;
      border-bottom: 1px solid #dcdfe6;
      .el-button{
        position: absolute;
        right: 0;
      }
    }
  }
}
.el-dialog__body{
  padding-top:0 ;
  .dia_top{
    text-align: center;
    margin-top: -3%;
  }
  .dialog_title{
    text-align: right;
    box-sizing: border-box;
    border: 1px solid #ebeef5;
    padding: 10px 10px 10px 0;
    border-bottom: none;
    .search_btn{
      margin-left: 20px;
    }
  }
}
.backBtn{
  margin-right:10%;
}
</style>